/* Naam en soort van het huisdier, alleen opgeslagen in de browser van de bezoeker.
   Er gaat niets naar een server. */
(function () {
  var KEY = 'lapusie:pet';

  function read() {
    try {
      var value = JSON.parse(window.localStorage.getItem(KEY));
      if (value && typeof value.name === 'string' && value.name) return value;
    } catch (e) {
      /* opslag geblokkeerd of kapot: ga door zonder profiel */
    }
    return null;
  }

  function write(pet) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(pet));
    } catch (e) {
      /* privévenster of geblokkeerd: profiel geldt dan alleen voor deze pagina */
    }
    current = pet;
  }

  function clear() {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {
      /* negeren */
    }
    current = null;
  }

  function sanitize(name) {
    return String(name || '')
      .replace(/[<>]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 24);
  }

  var current = read();

  function applySlots() {
    var root = document.documentElement;
    if (current) {
      root.setAttribute('data-pet-name', current.name);
      if (current.species) root.setAttribute('data-pet-species', current.species);
      else root.removeAttribute('data-pet-species');
    } else {
      root.removeAttribute('data-pet-name');
      root.removeAttribute('data-pet-species');
    }

    document.querySelectorAll('[data-pet-slot]').forEach(function (el) {
      var template = el.getAttribute('data-pet-template') || '{name}';
      if (current) {
        el.textContent = template.replace('{name}', current.name);
        el.hidden = false;
      } else {
        var fallback = el.getAttribute('data-pet-fallback');
        el.textContent = fallback || '';
        el.hidden = el.hasAttribute('data-pet-hide-empty') || !fallback;
      }
    });
  }

  function announce() {
    applySlots();
    document.dispatchEvent(new CustomEvent('lapusie:pet-change', { detail: current }));
  }

  window.LapusiePet = { get: function () { return current; }, set: function (name, species) {
    var clean = sanitize(name);
    if (!clean) return false;
    write({ name: clean, species: species || '' });
    announce();
    return true;
  }, clear: function () { clear(); announce(); }, sanitize: sanitize };

  if (typeof customElements !== 'undefined' && !customElements.get('pet-profile')) {
    customElements.define(
      'pet-profile',
      class PetProfile extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-pet-form]');
          this.formView = this.querySelector('[data-pet-form-view]');
          this.savedView = this.querySelector('[data-pet-saved-view]');
          this.input = this.querySelector('[data-pet-input]');

          if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
          var edit = this.querySelector('[data-pet-edit]');
          var wipe = this.querySelector('[data-pet-clear]');
          if (edit) edit.addEventListener('click', this.onEdit.bind(this));
          if (wipe) wipe.addEventListener('click', function () { window.LapusiePet.clear(); });

          this.onChange = function () {
            this.editing = false;
            this.render();
          }.bind(this);
          document.addEventListener('lapusie:pet-change', this.onChange);
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('lapusie:pet-change', this.onChange);
        }

        onSubmit(event) {
          event.preventDefault();
          var checked = this.form.querySelector('input[name="species"]:checked');
          var ok = window.LapusiePet.set(this.input.value, checked ? checked.value : '');
          if (!ok) this.input.focus();
        }

        onEdit() {
          this.editing = true;
          this.render();
          if (this.input) this.input.focus();
        }

        render() {
          var pet = window.LapusiePet.get();
          var showSaved = !!pet && !this.editing;
          if (this.formView) this.formView.hidden = showSaved;
          if (this.savedView) this.savedView.hidden = !showSaved;
          if (pet && this.input && this.editing) this.input.value = pet.name;
          applySlots();
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySlots);
  } else {
    applySlots();
  }
})();
